import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { Result } from '../../../../domain/models/http-response.model';
import { AuthRepository } from '../../../../domain/repositories/auth.repository';

@Injectable({
  providedIn: 'root',
})
export class LogoutUsecase
  implements Usecase<undefined, Promise<Result<any, any>>>
{
  constructor(private authRepository: AuthRepository) {}

  execute() {
    return this.authRepository.logout();
  }
}
